<template>
  <div class="popup-frame active">
    <div class="popup-container popup-dialog popup-dialog-centered justify-content-center">
      <div class="popup-package popup-entry-guard-box">
        <div class="popup-content">
          <div class="popup-header popup-coupon-header">
            <h4 class="popup-coupon-title">
              {{ $t('Bao.payment_promo_code_confirm') }}
            </h4>
            <a class="popup-close" @click.prevent="$emit('close')">
              <i class="fa-solid fa-xmark" aria-hidden="true" />
            </a>
          </div>

          <div class="popup-body entry-guard-body">
            <i18n path="Bao.payment_promo_code_confirm_msg" tag="p" class="entry-guard-text">
              <template v-slot:name>
                <!--eslint-disable-next-line -->
                <span v-if="card.name" class="entry-guard-count" v-html="card.name" />
                <span v-else class="entry-guard-count">{{ card.code }}</span>
              </template>
            </i18n>
            <p class="entry-guard-text entry-guard-sub">
              {{ $t('Bao.payment_promo_code_confirm_note') }}
            </p>
          </div>

          <div class="entry-guard-actions">
            <button type="button" class="coupon-btn entry-guard-go" @click="$emit('confirm')">
              {{ $t('Bao.payment_promo_code_confirm') }}
            </button>
            <button type="button" class="entry-guard-skip" @click="$emit('close')">
              {{ $t('Bao.payment_promo_code_confirm_cancel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositPromoConfirmModal',
  props: {
    card: {
      type: Object,
      required: true
    }
  }
}
</script>
